import Axios from 'lib/Axios';
import { APIResponse } from 'types/APIResponse';
import { DefaultPagination } from 'types/common';
import { CancelOrder, ProfileOrder } from 'types/Order';

export const _GetProfileOrders = (params?: DefaultPagination) =>
  Axios.get<APIResponse<ProfileOrder[]>>('/profile/orders', {
    params,
  }).then((res) => res.data);

export const _GetOrderDetails = (orderId: string) =>
  Axios.get<ProfileOrder>(`/profile/orders/${orderId}`).then((res) => res.data);

export const _CancelOrder = (data?: CancelOrder) =>
  Axios.post<CancelOrder>(`/profile/cancel-order/`, data).then((res) => res.data);
